import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import Button from '../../../../ui/button/button';
import MaterialCheckbox from '../../../../common/checkbox/material-checkbox';
import { BUTTON_VARIANTS } from '../../../../constants/button-variants';
import translation from '../../../../languages';
import { cartContainsFixedPriceOnly } from '../../../../reducers/cart';
import useAttachCredits from '../../../../services/credits/use-attach-credits';
import useDetachCredits from '../../../../services/credits/use-detach-credits';
import qualityEvents from '../../../../services/quality-events/quality-events';
import { setCheckoutSource } from '../../../../services/quality-events/quality-events-pages/checkout-page-quality-events';
import { MaterialCartSummaryProps } from '../material-cart-summary';

export type CartActionBlockPropsType = TranslationProps &
    Pick<MaterialCartSummaryProps, 'showBlinder'> & {
        cart: Cart;
        hundredPercentVoucher: boolean;
        goToPaymentPage: () => void;
        disabled?: boolean;
    };

const CartActionBlock: FC<CartActionBlockPropsType> = (props) => {
    const { cart, hundredPercentVoucher, goToPaymentPage, showBlinder, t, disabled } = props;
    const { usedCredits } = cart;

    const user = useSelector((state: RootState) => state.main.user);
    const { mutate: attachCredits } = useAttachCredits();
    const { mutate: detachCredits } = useDetachCredits();

    const changeCreditOption = () => {
        const { usedCredits } = cart;

        showBlinder(true);

        if (usedCredits) {
            detachCredits(undefined, { onSettled: () => showBlinder(false) });
        } else {
            attachCredits(undefined, { onSettled: () => showBlinder(false) });
        }
    };

    const handleGoToPayment = (): void => {
        const { cartItems } = cart;
        const cartTotalValue = cart.finalPrice;

        setCheckoutSource('generic');
        qualityEvents.checkoutPage.initiateCheckout({
            cartTotalValue,
            cartItems,
            internalPath: 'cart_page',
            onFinish: goToPaymentPage
        });
    };

    return (
        <>
            {Boolean(user.availableCredits && !hundredPercentVoucher && !cartContainsFixedPriceOnly(cart)) && (
                <>
                    <div className='credit-option mt-24'>
                        <MaterialCheckbox
                            title={(<span>{t('cart.cartSummary.usedCredits')}</span>) as unknown as string}
                            checked={Boolean(usedCredits)}
                            className='mr-2'
                            id='usedCredits'
                            type='checkbox'
                            checkedBgColor='dark'
                            onChange={() => changeCreditOption()}
                        />
                    </div>
                    <hr className='d-lg-none' />
                </>
            )}
            <span className='d-none d-lg-block'>
                <Button variant={BUTTON_VARIANTS.YELLOW} disabled={disabled} onClick={handleGoToPayment}>
                    {t('cart.cartSummary.goToPayment')}
                </Button>
            </span>
        </>
    );
};

const translate = translation('cart');

export default translate(CartActionBlock);
